<div (mouseenter)="openGapsPopover.show($event)" (mouseout)="openGapsPopover.hide()">
  {{ totalOpenGaps}}

  <app-popover #openGapsPopover>
    <div *ngFor="let numeratorRow of allOpenGaps; trackBy: trackByIndex; let i = index;">
      {{ numeratorRow }}
    </div>
  </app-popover>
</div>
